import React from 'react';

import { PaddingContainer } from '@components';
import { WeWorkWithProps } from './WeWorkWithProps';

import * as styles from './WeWorkWith.module.scss';

export const WeWorkWith: React.FC<WeWorkWithProps> = ({
	data,
	title = 'We work with:',
}) => {
	return (
		<PaddingContainer className={'white-bg'}>
			<div className={styles.weWorkWithContainer}>
				<h2 className="font-size-medium-title mb-4 mb-xl-5">{title}</h2>
				<div className="row no-gutters">
					{data.map((item, index) => (
						<div
							className="col-12 col-sm-6 col-md-4 col-xl-2 d-flex align-items-center py-3"
							key={item.name + index}
						>
							<img src={item.icon} />
							<p className="pl-4 font-18">{item.name}</p>
						</div>
					))}
				</div>
			</div>
		</PaddingContainer>
	);
};
